/**
 * Route for `white-label-tracking-domain-cname-with-ssl`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { WhiteLabelTrackingDomainCnameWithSslPage } from "../features/white-label-tracking-domain-cname-with-ssl/WhiteLabelTrackingDomainCnameWithSslPage";

export const whiteLabelTrackingDomainCnameWithSslRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/white-label-tracking-domain-cname-with-ssl",
	component: WhiteLabelTrackingDomainCnameWithSslPage,
});

export default whiteLabelTrackingDomainCnameWithSslRoute;
